import React from "react";

/**
 * Says plainly that a screen's content has no surface in the mobile app.
 *
 * Some admin sections persist correctly and answer 200, but nothing in the API
 * or the app ever reads what they write — so staff upload content, see a success
 * toast, and reasonably conclude it is live when no user can ever see it. A
 * silent success is indistinguishable from a working feature, which is the same
 * reasoning behind the `unsupported()` toast used for controls that cannot work
 * at all; this is its counterpart for controls that work but go nowhere.
 *
 * Delete the notice from a screen at the moment that screen's content gets a
 * real app surface — not before.
 */
export default function NotInAppNotice({ children }) {
  return (
    <div
      className="alert alert-warning"
      role="status"
      style={{ marginBottom: 16, fontSize: 13 }}
    >
      <strong>Not shown in the app yet.</strong> {children} Everything here is
      saved and stays available for when it does.
    </div>
  );
}
